import { render, staticRenderFns } from "./skeletonCourseList.vue?vue&type=template&id=191ef5be&scoped=true"
var script = {}
import style0 from "./skeletonCourseList.vue?vue&type=style&index=0&id=191ef5be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191ef5be",
  null
  
)

export default component.exports